import * as React from "react";

export interface IConfigurationDataHeaderProps {
    isSelected: boolean,
    isNewConfiguration: boolean,
    onNewConfigurationClick: (event: any) => void
}


export default class ConfigurationDataHeader extends React.Component<IConfigurationDataHeaderProps, any> {

    constructor() {
        super();
    }

    render() {
        return (
            <div className="row panel mainGridHeader">
                <div className="col-md-2">
                    {
                        this.props.isSelected ? (
                            <form>
                                <div className="form-group">
                                    <button className="btn btn-primary" onClick={this.props.onNewConfigurationClick} disabled={this.props.isNewConfiguration}>New Configuration</button>
                                </div>
                            </form>) : ""
                    }
                </div>
                <div className="col-md-10">
                    <table className="table table-bordered">
                        <thead>
                            <tr><th>Dynamic Values</th><th></th><th></th></tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td><strong>[COPY]</strong></td>
                                <td>Copy value from request with same property name.</td>
                                <td>
                                    <strong>Request</strong>: {"{..., 'Amount': 23, ...}"}
                                    <br/>
                                    <strong>Response declaration</strong>: {"{... 'Amount': '[COPY]' ...}"}
                                    <br/>
                                    <strong>Generated response</strong>: {"{... 'Amount': 23, ...}"}
                                </td>
                            </tr>
                            <tr>
                                <td><strong>[COPY|XXX]</strong></td>
                                <td>Copy value from request if there is property with same name. If not then copy value from request with defined <strong>XXX</strong> property name</td>
                                <td>
                                    <strong>Request</strong>: {"{..., 'TrackData': '23', ...}"}
                                    <br/>
                                    <strong>Response declaration</strong>: {"{... 'Account': '[COPY|TrackData]' ...}"}
                                    <br/>
                                    <strong>Generated response</strong>: {"{... 'Account': '23', ...}"}
                                </td>
                            </tr>
                            <tr>
                                <td><strong>[GEN_STRING_XX]</strong> where <strong>XX</strong> is number.</td>
                                <td>Generate string with XX length.</td>
                                <td>
                                    <strong>Response declaration</strong>: {"{... 'TransactionId': '[GEN_STRING_15]' ...}"}
                                    <br/>
                                    <strong>Generated response</strong>: {"{... 'TransactionId': '58a18f9d8ebd464', ...}"}
                                </td>
                            </tr>
                            <tr>
                                <td><strong>[XXXX]</strong> where <strong>XXXX</strong> is property name from request.</td>
                                <td>Copy value from request with defined property name.</td>
                                <td>
                                    <strong>Request</strong>: {"{..., 'Amount': 23.89, ...}"}
                                    <br/>
                                    <strong>Response declaration</strong>: {"{... 'AuthorizedAmount': '[Amount]' ...}"}
                                    <br/>
                                    <strong>Generated response</strong>: {"{... 'AuthorizedAmount': 23.89, ...}"}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./Scripts/components/ConfigurationDataHeader.tsx